
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 100 83","fill":"none","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M29.742 16.304c-5.187 0-9.392 3.981-9.392 8.892 0 4.912 4.205 8.893 9.392 8.893 5.186 0 9.391-3.981 9.391-8.893 0-4.911-4.207-8.892-9.391-8.892zM87.48 0H12.348C5.608 0 0 5.308 0 11.857v59.286C0 77.693 5.606 83 12.346 83h75.132C94.394 83 100 77.692 100 71.143V11.857C100.002 5.307 94.562 0 87.48 0zm3.13 69.902L63.844 35.46c-.489-.852-1.604-1.37-2.797-1.37-1.197 0-2.313.512-2.976 1.366L37.214 62.153l-7.257-8.54c-.674-.793-1.748-1.262-2.89-1.262-1.143 0-2.217.469-2.892 1.262L9.4 70.993c0-.006 0 .005 0 0l-.008-59.136c0-1.634 1.405-2.964 3.13-2.964h75.133c1.726 0 3.13 1.33 3.13 2.964v58.045h-.174z","fill":"currentColor"}})])
          )
        }
      }
    